module.exports = __webpack_public_path__ + "media/floorPlans/floorPlansFullService-6eb7e55e.png";